const css = `
@media screen {
.editor {
  position: relative;
  display: grid;
}
@keyframes tag-blink {
  0%, 100% { background-color: transparent; box-shadow: none; }
  25%, 75% { background-color: #ffe89e; box-shadow: 0 0 0 3px #f5b301; }
}
.tag-blink {
  animation: tag-blink 0.5s ease-in-out 3;
  border-radius: 3px;
}
}
.editor {
  padding-top: 60px;
  row-gap: 60px;
  z-index: 1;
}               

.layout-leaf-comment { 
  background: rgba(255, 213, 110, 0.4);
}
.layout-leaf-comment-active { 
  background: rgba(255, 213, 110, 1);
}

.styled-paragraph--active{
 outline: 1px dashed grey;
 outline-offset: 4px;
}
.editor-image--container,
.editor-table--container,
.editor-table-of-content--container {
  position: relative;
}
.editor-image--container .controls--container,
.editor-table--container .controls--container,
.editor-table-of-content--container .controls--container {
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 5px;
  top: 5px;
  right: 5px;
  transition: all 300ms ease-in-out;
  opacity: 0;
  padding: 2px;
}
.editor-image--container .controls--container button,
.editor-table--container .controls--container button,
.editor-table-of-content--container .controls--container button {
  background: transparent;
  height: 30px;
  width: 30px;
  border: 0;
  cursor: pointer;
  background: #f2f2f2;
  border-radius: 4px;
  box-shadow: 1px 1px 2px black;
  color: red;
}
.editor-image--container .controls--container i,
.editor-table--container .controls--container i,
.editor-table-of-content--container .controls--container i {
  font-family: 'Font Awesome 6 Pro', 'Font Awesome 6 Free', 'Font Awesome 5 Free', 'FontAwesome', sans-serif !important; 
}
.editor-image--container:hover .controls--container,
.editor-table--container:hover .controls--container,
.editor-table-of-content--container:hover .controls--container {
  opacity: 1;
}

.editor-image--container--block-tagged,
.taggable-table-wrapper--block-tagged {
  outline: 2px solid #62a4b9;
  outline-offset: 1px;
  cursor: pointer;
}
.taggable-table-wrapper {
  position: relative;
}

.editor-image--tag-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  border: 1px solid;
  font-size: 12px;
  line-height: 1;
  z-index: 5;
}
.editor-image--tag-badge__count {
  font-weight: 600;
}
.editor-image--tag-badge__dots {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
}
.editor-image--tag-badge__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  cursor: pointer;
}
.editor-image--tag-badge__continue {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0;
  height: 18px;
  margin-left: 0;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  color: inherit;
  cursor: pointer;
  font-size: 11px;
  opacity: 0;
  overflow: hidden;
  transition: opacity 150ms ease-in-out, width 150ms ease-in-out, margin-left 150ms ease-in-out;
}
.editor-image--tag-badge:hover .editor-image--tag-badge__continue {
  opacity: 1;
  width: 18px;
  margin-left: 2px;
}
.editor-image--tag-badge__continue:hover {
  background: rgba(255, 255, 255, 0.95);
}

.editor-table-of-content--content:empty::after {
  content: "[Empty table of content]";
  color: red;
}
@media screen {
  .content-overflow {
    box-shadow: inset 0 -3px 0 red !important;
  }
  .page-content-overflow::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: var(--content-overflow-line, 100%);
    height: 3px;
    background: red;
    pointer-events: none;
    z-index: 2;
  }
}

.coverage-scope {
  box-shadow: inset 0 0 0 1px rgba(99, 102, 241, 0.45);
  background-color: rgba(99, 102, 241, 0.04);
  border-radius: 3px;
}

.coverage-missing {
  box-shadow: inset 0 0 0 2px rgba(239, 68, 68, 0.7);
  background-color: rgba(239, 68, 68, 0.08);
  border-radius: 3px;
}

.coverage-anchor {
  box-shadow: inset 0 0 0 2px #1f2937;
  background-color: rgba(31, 41, 55, 0.05);
  border-radius: 3px;
}
.coverage-anchor--block {
  box-shadow: inset 0 0 0 2px #3b82f6;
  background-color: rgba(59, 130, 246, 0.07);
}
.coverage-anchor--strict {
  box-shadow: inset 0 0 0 2px #d946ef;
  background-color: rgba(217, 70, 239, 0.07);
}
.coverage-anchor--all-cells {
  box-shadow: inset 0 0 0 2px #d946ef;
  background-color: rgba(217, 70, 239, 0.07);
}

.taggable-table-container {
  user-select: none;
  -webkit-user-select: none;
}
.taggable-table-container .cell {
  cursor: cell;
}
.taggable-table-container .cell.selected {
 outline: 2px solid #1a73e8;
background-color: rgba(26, 115, 232, 0.1);
}

@media print {
  .editor {
    padding-top: 0;
    row-gap: 0;
  }
  .page-content {
    page-break-after: always;
  }
  .page-content:last-child {
    page-break-after: auto;
  }
}
`;

export default css;
